import {useEffect, useRef} from 'react';
import {useIsInViewPort} from "./useIsInViewPort";

export const useSwiperHintSlide = (
  swiperRef,
  containerRef,
  enabled = true,
  hintAnimationParams = {}
) => {
	const isInView = useIsInViewPort(containerRef, {threshold: 0.1}); // 0.1 = minimum 10% (1 = 100%) in viewport
	const hasRunRef = useRef(false);
	const timeoutRef = useRef(null);

	useEffect(() => {
		if (!enabled) {
			hasRunRef.current = false;
			return;
		}

		if (!isInView || hasRunRef.current) {
			return;
		}

		const swiperInstance = swiperRef.current?.swiper;
		if (!swiperInstance) {
			return;
		}

		hasRunRef.current = true;

		const animateTo = hintAnimationParams.animateTo ?? 1;
		const returnTo = hintAnimationParams.returnTo ?? 0;
		const delay = hintAnimationParams.delay ?? 2000;

		swiperInstance.slideTo(animateTo, 400, true);

		timeoutRef.current = setTimeout(() => {
			swiperInstance.slideTo(returnTo, 400, true);
		}, delay);

		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, [
		isInView,
		enabled,
		swiperRef,
		hintAnimationParams.animateTo,
		hintAnimationParams.returnTo,
		hintAnimationParams.delay
	]);
};